// extracted by mini-css-extract-plugin
export default {"cls1":"Modal-cls1___aed9b01591c754cf360","cls2":"Modal-cls2__b765e95ef6bdbcd139f5 Modal-cls1___aed9b01591c754cf360"};